import { render, staticRenderFns } from "./OTextField.vue?vue&type=template&id=2613f143&scoped=true&"
import script from "./OTextField.vue?vue&type=script&lang=js&"
export * from "./OTextField.vue?vue&type=script&lang=js&"
import style0 from "./OTextField.vue?vue&type=style&index=0&id=2613f143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613f143",
  null
  
)

export default component.exports